import React from 'react';
import classnames from 'clsx';
import type { ScrollerProps } from '../types';
import { TestIds } from '../../../constants';
import styles from './Scroller.scss';

export default (props: ScrollerProps) => {
  const { direction, onClick } = props;
  return (
    <div
      className={classnames(styles.container, styles.button)}
      onClick={onClick}
      data-testid={TestIds.scroller}
      aria-hidden="true"
    >
      <span className={direction === 'right' ? styles.right : styles.left} />
    </div>
  );
};
